import Box from './Box';
import {CustomText} from '../text';
import If from '../../conditional/If';
import {Touchable} from '../touchable';

import {LayoutChangeEvent, StyleSheet} from 'react-native';
import React, {useCallback, useState} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

interface ExpandViewProps {
  children: React.ReactNode;
}

const ExpandView: React.FC<ExpandViewProps> = props => {
  const theme = useColorThemeType();
  const fontTheme = useFontTheme('muli');
  const tolerance = 200;

  const [descHeight, setDescHeight] = useState<number>(0);
  const [expand, setExpand] = useState<boolean>(false);

  const expandText: React.JSX.Element = (
    <CustomText
      style={[
        styles.expandText,
        {
          fontFamily: fontTheme?.[600]?.normal,
          color: theme?.text?.blue[300],
        },
      ]}>
      {expand ? 'Read less' : 'Read more'}
    </CustomText>
  );

  return (
    <React.Fragment>
      <Box
        onLayout={useCallback(
          (event: LayoutChangeEvent) => {
            let {height} = event.nativeEvent.layout;
            if (!descHeight) setDescHeight(Math.floor(height));
          },
          [descHeight],
        )}>
        <Box
          style={[
            styles.subContainer,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              height: descHeight > tolerance && !expand ? tolerance : 'auto',
            },
          ]}>
          {props.children}
        </Box>
      </Box>

      <If condition={descHeight > tolerance}>
        <Touchable
          style={styles.expand}
          onPress={useCallback(() => {
            setExpand(!expand);
          }, [expand])}>
          {expandText}
        </Touchable>
      </If>
    </React.Fragment>
  );
};

export default React.memo(ExpandView);

const styles = StyleSheet.create({
  subContainer: {overflow: 'hidden'},
  expand: {
    marginLeft: 3,
    marginTop: 10,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  expandText: {textDecorationLine: 'underline'},
});
